import type { PlatformEnv } from '@evc/platform';
import { ENVIRONMENT } from '@evc/platform';
import type { WebComponentsEnv } from '@evc/web-components';
import type { SharedEnv } from '@shared/services/config/config.type';

export { ENVIRONMENT } from '@evc/platform';

export type AppEnv = SharedEnv & PlatformEnv & WebComponentsEnv;

export const environment: AppEnv = {
  APP_NAME: 'equipment-manager',
  ENV: ENVIRONMENT.production,
  USE_CONNECT_PLATFORM: true,
  AUTH_FORCE_ORGANIZATION: true,
  PORT: 8085,
  PROTECTED_URIS: {
    DEVICE: 'https://device.api.ca.connect.dev-evcnt.com/',
  },
  DEBUG_MOCK_SOFTWARE_DOWNLOADS: false,
};
